const MISCELLANEOUS = {
  componentDataAid: "bottomsheetEnterReferral",
  title: {
    text: 'Got a referral code?',
    dataAid: 'title'
  },
  inputLabel: {
    text: "Add referral code here"
  },
  applyCta: {
    text: "Apply"
  },
  referralApplySuccessMsg: {
    text: "Referral code applied successfully"
  },
  emptyReferralErrMsg: {
    text: "Please enter referral code to proceed"
  },
  invalidReferralErrMsg: {
    text: "Incorrect referral code applied"
  }
}

const APPLY_REFERRAL_BOTTOMSHEET = MISCELLANEOUS;
export default APPLY_REFERRAL_BOTTOMSHEET;
